import React, { useState, useContext } from "react";
import Heading from "components/Elements/Heading";
import CatalogSourceSelected from "pages/SourcePage/CatalogSourceSelected";
import SelectAccount from "pages/SourcePage/SelectAccounts";
import { selectIcon } from "components/Utils/Utils.js";

import { SourceContext } from "pages/SourcePage/SourcesMasterPage";

const DataConnectors = ({ data }) => {
  const props = useContext(SourceContext);
  const url = new URL(window.location.href);
  const urlParams = url.hash && new URLSearchParams(url.hash);

  const lastUrlParameter =
    url.hash.length > 0 && urlParams.get("state")
      ? urlParams.get("state").split("/").pop()
      : window.location.pathname.split("/").pop();

  const [sidebarOpen, setSidebarOpen] = useState(
    data && data.name.toLowerCase() === lastUrlParameter
  );

  const [showSelectAccount, setShowSelectAccount] = useState(
    data && data.name.toLowerCase() === lastUrlParameter
  );

  const displayConnectors = () => {
    if (data.active === true) {
      return (
        <div className="source-list_border" key={data.id} onClick={openHandler}>
          <img
            src={selectIcon(data.type)}
            alt={data.type}
            width="40"
            height="40"
          />
          <Heading size={4}>{data.name}</Heading>
          <small>Social</small>
        </div>
      );
    }
  };

  const openHandler = () => {
    if (!sidebarOpen) {
      window.history.replaceState({}, "", "/settings/sources");
      setSidebarOpen(true);
      props.disableCatalogButton();
    } else {
      setSidebarOpen("sidebar close-selected");
      setTimeout(() => {
        setSidebarOpen(false);
      }, 600);
    }
  };

  const closeSourceSelectedHandler = () => {
    props.enableCatalogButton();
    setShowSelectAccount(false);
    setSidebarOpen(false);
  };

  let sidebar;
  if (sidebarOpen) {
    sidebar = showSelectAccount ? (
      // SELECT ACCOUNT
      <SelectAccount
        closeSidebar={closeSourceSelectedHandler}
        sidebar={"sidebar"}
        sourceData={data}
      />
    ) : (
      // INFO PAGE
      <CatalogSourceSelected
        closeSidebar={closeSourceSelectedHandler}
        sidebar={"sidebar"}
        sourceData={data}
      />
    );
  }

  return (
    <section>
      {sidebar}
      {displayConnectors()}
    </section>
  );
};
export default DataConnectors;
